import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SkillService } from 'src/app/common/services/skill/skill.service';
import { StatusEnum } from 'src/app/common/utils/status-enum.models';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { InputTypeEnum } from 'src/app/shared/input/enums/input-type.enum';
import { CategoryService } from '../../category/service/category.service';
import {
  GetCategoryRequest,
  GetCategoryResponseItem,
} from '../../category/service/models/category.service.model';
import {
  GetClientRequest,
  GetClientsResponse,
  GetSkillRequest,
  GetSkillResponse,
} from '../../client/models/client.model';
import { ClientService } from '../../client/service/client.service';
import {
  GetUserResponse,
  GetUserRequest,
} from '../../user/service/models/user.service.model';
import { UserService } from '../../user/service/user.service';
import { CategoryAnalysisReportGetFilter } from '../service/models/category-analysis-report.service.model';
import { Observable, tap, catchError, of } from 'rxjs';
import { PagedRequest } from 'src/app/paged-request.model';

@Component({
  selector: 'app-category-analysis-report-filter',
  templateUrl: './category-analysis-report-filter.component.html',
  styleUrls: ['./category-analysis-report-filter.component.scss'],
})
export class CategoryAnalysisReportFilterComponent implements OnInit {
  constructor(
    public formBuilder: FormBuilder,
    public userService: UserService,
    public categoryService: CategoryService,
    public clientService: ClientService,
    public skillService: SkillService,
    private toastrService: ToastrService
  ) {}

  @Output() filterEmmiter: EventEmitter<CategoryAnalysisReportGetFilter> =
    new EventEmitter<CategoryAnalysisReportGetFilter>();

  isLoading: boolean = false;
  isOpen: boolean = true;
  isValidPeriod: boolean = false;

  supervisors: string[] = [];
  selectedSupervisors: string[] = [];
  originalSupervisors: GetUserResponse[] = [];

  attendants: string[] = [];
  selectedAttendants: string[] = [];
  originalAttendants: GetUserResponse[] = [];

  categories: string[] = [];
  selectedCategories: string[] = [];
  originalCategories: GetCategoryResponseItem[] = [];

  clients: string[] = [];
  selectedClients: string[] = [];
  originalClients: GetClientsResponse[] = [];

  skills: string[] = [];
  selectedSkills: string[] = [];
  originalSkills: GetSkillResponse[] = [];

  shifts: string[] = ['Manhã', 'Tarde', 'Noite', 'Madrugada'];
  selectedShifts: string[] = [];
  loadingShifts = false;

  types: string[] = ['Áudio', 'Chat'];
  selectedTypes: string[] = [];

  loadingClients: boolean = false;
  loadingMoreClients: boolean = false;
  loadingSearchClients: boolean = false;
  totalItemsClients: number = 0;
  clientFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    sortAscending: true,
    sortBy: 'Name',
  } as GetClientRequest;

  loadingSkills: boolean = false;
  loadingSearchSkills: boolean = false;
  loadingMoreSkills: boolean = false;
  totalItemsSkills: number = 0;
  skillsFilter = {
    pageNumber: 1,
    pageSize: 10,
    sortAscending: true,
    sortBy: 'Code',
  } as GetSkillRequest;

  loadingCells: boolean = false;
  loadingSearchCells: boolean = false;
  loadingMoreCells: boolean = false;
  totalItemsCells: number = 0;
  cells: string[] = [];
  selectedCells: string[] = [];
  cellsFilter = {
    pageNumber: 1,
    pageSize: 10,
    sortAscending: true,
    sortBy: 'Cell',
  } as PagedRequest;

  loadingSubcells: boolean = false;
  loadingSearchSubCells: boolean = false;
  loadingMoreSubCells: boolean = false;
  totalItemsSubCells: number = 0;
  selectedSubCells: string[] = [];
  subCells: string[] = [];
  subCellsFilter = {
    pageNumber: 1,
    pageSize: 10,
    sortAscending: true,
    sortBy: 'SubCell',
  } as PagedRequest;

  loadingSupervisors: boolean = false;
  loadingSearchSupervisors: boolean = false;
  loadingMoreSupervisors: boolean = false;
  totalItemsSupervisors: number = 0;
  supervisorsFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    profiles: ['SUPERVISOR'],
    sortAscending: true,
    sortBy: 'Name',
  } as GetUserRequest;

  loadingAttendants: boolean = false;
  loadingSearchAttendants: boolean = false;
  loadingMoreAttendants: boolean = false;
  totalItemsAttendants: number = 0;
  attendantsFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    profiles: ['ATENDENTE'],
    sortAscending: true,
    sortBy: 'Name',
  } as GetUserRequest;

  loadingCategories: boolean = false;
  loadingSearchCategories: boolean = false;
  loadingMoreCategories: boolean = false;
  totalItemsCategories: number = 0;
  categoryFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    sortAscending: true,
    sortBy: 'Name',
  } as GetCategoryRequest;

  form = this.formBuilder.group({
    initialDate: ['', Validators.required],
    finalDate: ['', Validators.required],
    attendants: [['']],
    supervisors: [['']],
    categories: [['']],
    clients: [['']],
    skills: [['']],
    cells: [[]],
    subCells: [[]],
    shifts: [['']],
    types: [['']],
  });

  InputTypeEnum = InputTypeEnum;
  ButtonColorEnum = ButtonColorEnum;

  ngOnInit() {
    this.form.controls.supervisors.valueChanges.subscribe(
      (value: string[] | null) => {
        if (value && value.length > 0) {
          var supervisorIds = this.getSupervisorsIdFromText(value);

          var supervisors = this.originalSupervisors.filter((s) =>
            supervisorIds.includes(s.id)
          );

          const filteredAttendants = supervisors
            .map((s) => s.attendants.map((a) => a))
            .flat();

          this.attendants = filteredAttendants.map(
            (a) => a.name.trim() + ' | ' + a.functional
          );
          this.selectedAttendants = [];
          this.form.controls.attendants.reset();
        } else {
          this.attendants = this.originalAttendants.map(
            (attendant) => attendant.name + ' | ' + attendant.functional
          );

          this.selectedAttendants = [];
          this.form.controls.attendants.reset();
        }

        if (
          !this.form.controls.supervisors.value ||
          this.form.controls.supervisors.value.length === 0 ||
          (this.form.controls.supervisors.value.length === 1 &&
            this.form.controls.supervisors.value[0] === '')
        ) {
          this.attendants = this.originalAttendants.map(
            (attendant) => attendant.name + ' | ' + attendant.functional
          );

          this.selectedAttendants = [];
          this.form.controls.attendants.reset();
        }
      }
    );

    this.form.controls.clients.valueChanges.subscribe(
      (value: string[] | null) => {
        if (value && value.length > 0 && value[0] !== '') {
          var clientIds = this.getClientsIdFromText(value);

          var clients = this.originalClients.filter((s) =>
            clientIds.includes(s.id)
          );

          const filteredSkills = clients
            .map((s) => s.skills.map((a) => a))
            .flat();

          this.skills = filteredSkills.map(
            (i) => i.code + ': ' + i.cell + ' — ' + i.subCell
          );

          this.selectedSkills = [];
          this.form.controls.skills.reset();
        } else {
          this.skills = this.originalSkills.map(
            (i) => i.code + ': ' + i.cell + ' — ' + i.subCell
          );
          this.selectedSkills = [];
          this.form.controls.skills.reset();
        }

        if (
          !this.form.controls.clients.value ||
          this.form.controls.clients.value.length === 0 ||
          (this.form.controls.clients.value.length === 1 &&
            this.form.controls.clients.value[0] === '')
        ) {
          this.skills = this.originalSkills.map(
            (i) => i.code + ': ' + i.cell + ' — ' + i.subCell
          );
          this.selectedSkills = [];
          this.form.controls.skills.reset();
        }
      }
    );

    this.getCategories(null);
    this.getClients(null);
    this.getSkills();
    this.getCells();
    this.getSubCells();
    this.getSupervisors(null);
    this.getAttendants(null);
  }

  isAttendantsDisabled(): boolean {
    var supervisors = this.form.controls.supervisors;
    return (
      !supervisors ||
      !supervisors.value ||
      supervisors.value.length == 0 ||
      (supervisors.value.length == 1 && supervisors.value[0] === '')
    );
  }

  getFilteredShiftsValue(text: string[] | null): string[] | null {
    if (!text || text.length == 0 || (text.length == 1 && text[0] == ''))
      return null;
    return this.form.controls.shifts.value;
  }

  getAttendantsPlaceholder(): string {
    var supervisors = this.form.controls.supervisors;
    if (
      supervisors &&
      supervisors.value &&
      supervisors.value.length > 0 &&
      supervisors.value[0] !== ''
    ) {
      return this.attendants.length > 0
        ? 'Selecione múltiplos atendentes'
        : 'Nenhum atendente disponível';
    }
    return 'Selecione múltiplos atendentes';
  }

  getCategories(name: string | null) {
    this.categoryFilter.pageNumber = 1;

    if (name) {
      this.categoryFilter.name = name;
      this.loadingSearchCategories = true;
    } else {
      this.loadingCategories = true;
      this.categoryFilter.name = null;
    }

    this.categoryService.get(this.categoryFilter).subscribe({
      next: (data) => {
        this.originalCategories = data.items;
        this.categories = data.items.map((category) =>
          category.client === null
            ? category.name
            : category.name + ' (' + category.client?.name + ') '
        );
        this.totalItemsCategories = data.totalItems;
        this.loadingCategories = false;
        this.loadingSearchCategories = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar as categorias.');
        this.loadingCategories = false;
        this.loadingSearchCategories = false;
      },
    });
  }

  getMoreCategories() {
    if (this.totalItemsCategories != this.categories.length) {
      this.loadingMoreCategories = true;

      if (this.categoryFilter.pageNumber) this.categoryFilter.pageNumber += 1;

      this.categoryService.get(this.categoryFilter).subscribe({
        next: (data) => {
          this.originalCategories = this.originalCategories.concat(data.items);
          this.totalItemsCategories = data.totalItems;

          this.categories = this.categories.concat(
            data.items.map((category) =>
              category.client === null
                ? category.name
                : category.name + ' (' + category.client?.name + ') '
            )
          );

          this.loadingMoreCategories = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar as categorias.');
          this.loadingMoreCategories = false;
        },
      });
    }
  }

  getClients(name: string | null) {
    this.clientFilter.pageNumber = 1;

    if (name) {
      this.clientFilter.name = name;
      this.loadingSearchClients = true;
    } else {
      this.loadingClients = true;
      this.clientFilter.name = null;
    }

    this.clientService.get(this.clientFilter).subscribe({
      next: (data) => {
        this.originalClients = data.items;
        this.clients = data.items.map((i) => i.name + ' | ' + i.cnpj);
        this.totalItemsClients = data.totalItems;
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os clientes.');
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
    });
  }

  getMoreClients() {
    if (this.totalItemsClients != this.clients.length) {
      this.loadingMoreClients = true;
      if (this.clientFilter.pageNumber) this.clientFilter.pageNumber += 1;

      this.clientService.get(this.clientFilter).subscribe({
        next: (data) => {
          this.originalClients = this.originalClients.concat(data.items);
          this.totalItemsClients = data.totalItems;
          this.clients = this.clients.concat(
            data.items.map((i) => i.name + ' | ' + i.cnpj)
          );
          this.loadingMoreClients = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os clientes.');
          this.loadingMoreClients = false;
        },
      });
    }
  }

  getSkills() {
    this.skillsFilter.pageNumber = 1;
    this.loadingSkills = true;

    this.skillService.get(this.skillsFilter).subscribe({
      next: (data) => {
        this.originalSkills = data.items;

        this.skills = data.items.map(
          (i) => i.code + ': ' + i.cell + ' — ' + i.subCell
        );
        this.totalItemsSkills = data.totalItems;
        this.loadingSkills = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar as skills.');
        this.loadingSkills = false;
      },
    });
  }

  getMoreSkills() {
    if (this.totalItemsSkills != this.skills.length) {
      this.loadingMoreSkills = true;
      if (this.skillsFilter.pageNumber) this.skillsFilter.pageNumber += 1;

      this.skillService.get(this.skillsFilter).subscribe({
        next: (data) => {
          this.originalSkills = this.originalSkills.concat(data.items);
          this.totalItemsSkills = data.totalItems;
          this.skills = this.skills.concat(
            data.items.map((i) => i.code + ': ' + i.cell + ' — ' + i.subCell)
          );
          this.loadingMoreSkills = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar as skills.');
          this.loadingMoreSkills = false;
        },
      });
    }
  }

  getCells() {
    this.cellsFilter.pageNumber = 1;
    this.loadingCells = true;

    this.skillService.getCells(this.cellsFilter).subscribe({
      next: (data) => {
        this.cells = data.items;
        this.totalItemsCells = data.totalItems;
        this.loadingCells = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar as células.');
        this.loadingCells = false;
      },
    });
  }

  getMoreCells() {
    if (this.totalItemsCells != this.cells.length) {
      this.loadingMoreCells = true;
      if (this.cellsFilter.pageNumber) this.cellsFilter.pageNumber += 1;

      this.skillService.getCells(this.cellsFilter).subscribe({
        next: (data) => {
          this.cells = this.cells.concat(data.items);
          this.totalItemsCells = data.totalItems;
          this.loadingMoreCells = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar as células.');
          this.loadingMoreCells = false;
        },
      });
    }
  }

  getSubCells() {
    this.subCellsFilter.pageNumber = 1;
    this.loadingSubcells = true;

    this.skillService.getSubCells(this.subCellsFilter).subscribe({
      next: (data) => {
        this.subCells = data.items;
        this.totalItemsSubCells = data.totalItems;
        this.loadingSubcells = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar as sub-células.');
        this.loadingSubcells = false;
      },
    });
  }

  getMoreSubCells() {
    if (this.totalItemsSubCells != this.subCells.length) {
      this.loadingMoreSubCells = true;
      if (this.subCellsFilter.pageNumber) this.subCellsFilter.pageNumber += 1;

      this.skillService.getSubCells(this.subCellsFilter).subscribe({
        next: (data) => {
          this.subCells = this.subCells.concat(data.items);
          this.totalItemsSubCells = data.totalItems;
          this.loadingMoreSubCells = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar as sub-células.');
          this.loadingMoreSubCells = false;
        },
      });
    }
  }

  getSupervisors(name: string | null) {
    this.supervisorsFilter.pageNumber = 1;

    if (name) {
      this.supervisorsFilter.name = name;
      this.loadingSearchSupervisors = true;
    } else {
      this.loadingSupervisors = true;
      this.supervisorsFilter.name = null;
    }

    this.userService.get(this.supervisorsFilter).subscribe({
      next: (data) => {
        this.originalSupervisors = data.items;
        this.supervisors = data.items.map(
          (supervisor) => supervisor.name + ' | ' + supervisor.functional
        );
        this.totalItemsSupervisors = data.totalItems;
        this.loadingSupervisors = false;
        this.loadingSearchSupervisors = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os supervisores.');
        this.loadingSupervisors = false;
        this.loadingSearchSupervisors = false;
      },
    });
  }

  getMoreSupervisors() {
    if (this.totalItemsSupervisors != this.supervisors.length) {
      this.loadingMoreSupervisors = true;
      if (this.supervisorsFilter.pageNumber)
        this.supervisorsFilter.pageNumber += 1;

      this.userService.get(this.supervisorsFilter).subscribe({
        next: (data) => {
          this.originalSupervisors = this.originalSupervisors.concat(
            data.items
          );
          this.supervisors = this.supervisors.concat(
            data.items.map(
              (supervisor) => supervisor.name + ' | ' + supervisor.functional
            )
          );
          this.totalItemsSupervisors = data.totalItems;
          this.loadingMoreSupervisors = false;
        },
        error: () => {
          this.toastrService.error(
            'Não foi possível carregar os supervisores.'
          );
          this.loadingMoreSupervisors = false;
        },
      });
    }
  }

  getAttendants(name: string | null) {
    this.attendantsFilter.pageNumber = 1;

    if (name) {
      this.attendantsFilter.name = name;
      this.loadingSearchAttendants = true;
    } else {
      this.loadingAttendants = true;
      this.attendantsFilter.name = null;
    }

    this.userService.get(this.attendantsFilter).subscribe({
      next: (data) => {
        this.originalAttendants = data.items;
        this.attendants = data.items.map(
          (attendant) => attendant.name + ' | ' + attendant.functional
        );
        this.totalItemsAttendants = data.totalItems;
        this.loadingAttendants = false;
        this.loadingSearchAttendants = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os atendentes.');
        this.loadingAttendants = false;
        this.loadingSearchAttendants = false;
      },
    });
  }

  getMoreAttendants() {
    if (this.totalItemsAttendants != this.attendants.length) {
      this.loadingMoreAttendants = true;
      if (this.attendantsFilter.pageNumber)
        this.attendantsFilter.pageNumber += 1;

      this.userService.get(this.attendantsFilter).subscribe({
        next: (data) => {
          this.originalAttendants = this.originalAttendants.concat(data.items);
          this.attendants = this.attendants.concat(
            data.items.map(
              (attendant) => attendant.name + ' | ' + attendant.functional
            )
          );
          this.totalItemsAttendants = data.totalItems;
          this.loadingMoreAttendants = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os atendentes.');
          this.loadingMoreAttendants = false;
        },
      });
    }
  }

  getSkillsPlaceholder(): string {
    const clients = this.form.controls.clients.value;
    if (clients && clients.length > 0 && clients[0] !== '') {
      return this.skills.length > 0
        ? 'Selecione múltiplas skills'
        : 'Nenhuma skill disponível';
    }
    return 'Selecione múltiplas skills';
  }

  clear() {
    this.form.reset({
      initialDate: '',
    });
    this.selectedCategories = [];
    this.selectedSupervisors = [];
    this.selectedAttendants = [];
    this.selectedClients = [];
    this.selectedSkills = [];
    this.selectedCells = [];
    this.selectedSubCells = [];
    this.selectedShifts = [];
    this.selectedTypes = [];
  }

  generate() {
    let filter: CategoryAnalysisReportGetFilter =
      {} as CategoryAnalysisReportGetFilter;

    filter.startDate = this.form.controls.initialDate.value ?? '';
    filter.endDate = this.form.controls.finalDate.value ?? '';

    this.isValidPeriod = this.isValidDate(filter.startDate, filter.endDate);

    if (!this.isValidPeriod) {
      this.isLoading = false;
      return;
    }

    filter.attendants = this.getAttendantsIdFromText(
      this.form.controls.attendants.value || []
    );

    filter.categories = this.getCategoriesIdFromName(
      this.form.controls.categories.value || []
    );

    filter.clients = this.getClientsIdFromText(
      this.form.controls.clients.value || []
    );

    filter.skills = this.getSkillIdFromText(
      this.form.controls.skills.value || []
    );

    filter.cells = this.form.controls.cells.value || [];

    filter.subcells = this.form.controls.subCells.value || [];

    filter.shifts = this.getFilteredShiftsValue(
      this.form.controls.shifts.value
    );

    var types: number[] | null;

    if (
      !this.form.controls.types ||
      !this.form.controls.types.value ||
      (this.form.controls.types.value.length == 1 &&
        this.form.controls.types.value[0].trim() == '')
    )
      types = null;
    else {
      types =
        this.form.controls.types.value?.map((i) => {
          return this.types.indexOf(i);
        }) ?? null;
    }

    filter.types = types;

    if (
      this.form.controls.supervisors.value &&
      this.form.controls.supervisors.value.length > 0 &&
      this.selectedAttendants &&
      this.selectedAttendants.length <= 0
    ) {
      this.form.get('attendants')?.updateValueAndValidity();
      this.form.patchValue({
        attendants: this.attendants,
      });

      filter.attendants = [];
      filter.attendants = this.getAttendantsIdFromText(this.attendants);
    }

    this.filterEmmiter.emit(filter);

    this.isOpen = false;
  }

  getSkillIdFromText(text: string[]): string[] | null {
    if (!text || text.length === 0) return null;

    var skills: string[] = [];

    for (let i = 0; i < text.length; i++) {
      if (!text[i] || text[i].trim() === '') return null;

      var [code, cellAndSubCell] = text[i].split(':').map((i) => i.trim());
      var [cell, subCell] = cellAndSubCell.split('—').map((i) => i.trim());

      var skillFiltered = this.originalSkills.find(
        (i) =>
          i.code.toString() === code &&
          i.cell.trim() === cell &&
          i.subCell.trim() === subCell
      );

      if (!skillFiltered || skillFiltered == undefined) {
        var clients = this.form.controls.clients;

        if (
          clients &&
          clients.value &&
          clients.value.length > 0 &&
          clients.value[0] != ''
        ) {
          const filteredClients = this.originalClients.filter((client) =>
            clients.value?.includes(client.name)
          );

          skillFiltered = filteredClients
            .flatMap((client) => client.skills)
            .find(
              (skill) =>
                skill.code.toString() === code &&
                skill.cell.trim() === cell &&
                skill.subCell.trim() === subCell
            );

          if (!skillFiltered) return null;
        }
      }

      if (skillFiltered) skills.push(skillFiltered.id);
    }

    return skills;
  }

  getSupervisorsIdFromText(text: string[]): string[] {
    let supervidorIds: string[] = [];

    text.forEach((i) => {
      var [name, functionalString] = i.split('|').map((part) => part.trim());
      var supervisor = this.originalSupervisors.find(
        (j) =>
          j.functional.toString() === functionalString &&
          j.name.trim() === name.trim()
      );

      if (supervisor) supervidorIds.push(supervisor.id);
    });

    return supervidorIds;
  }

  getAttendantsIdFromText(text: string[]): string[] {
    let attendantIds: string[] = [];

    text.forEach((i) => {
      var [name, functionalString] = i.split('|').map((part) => part.trim());

      var attendant = this.originalAttendants.find(
        (j) =>
          j.functional.toString().trim() == functionalString.trim() &&
          j.name.trim() == name.trim()
      );

      if (attendant) attendantIds.push(attendant.id);
    });

    return attendantIds;
  }

  getCategoriesIdFromName(categories: string[]): string[] {
    let categoryIds: string[] = [];

    categories.forEach((c) => {
      let categoryName = c.split('(')[0].trim();
      let category = this.originalCategories.find(
        (c) => c.name.trim() === categoryName.trim()
      );
      if (category) categoryIds.push(category.id);
    });

    return categoryIds;
  }

  getClientsIdFromText(clients: string[]): string[] {
    if (!clients || clients.length === 0) return [];
    let clientsId: string[] = [];
    clients.forEach((name) => {
      let clientName = name.split('|')[0].trim();
      let client = this.originalClients.find(
        (i) => i.name.trim() === clientName.trim()
      );
      if (client) clientsId.push(client.id);
    });

    return clientsId;
  }

  isFormComplete() {
    return (
      this.form.controls.initialDate.valid && this.form.controls.finalDate.valid
    );
  }

  handleToggleAccordion() {
    this.isOpen = !this.isOpen;
  }

  resetPeriod() {
    this.isValidPeriod = this.isValidDate(
      this.form.controls.initialDate.value ?? '',
      this.form.controls.finalDate.value ?? ''
    );
  }

  isValidDate(startDate: string, endDate: string) {
    return startDate != '' && endDate != '';
  }
}
